import { AppDispatch } from 'app/store';

import authService from 'features/auth/authService';
import { updateUser } from 'features/auth/authSlice';

import { GuideCompleted } from 'types/tour';

import { GuideType } from 'constants/enums';

import { getGuidePagesSettings } from './getGuidePagesSettings';

interface DismissGuideParams {
  guideCompleted: GuideCompleted;
  dispatch: AppDispatch;
  catchError: (params: {
    error: unknown;
    default: { message: string };
  }) => void;
  errorMessage: string;
  onClose?: () => void;
}

export const dismissGuide = async ({
  guideCompleted,
  dispatch,
  catchError,
  errorMessage,
  onClose
}: DismissGuideParams): Promise<void> => {
  const guideCompletedWithDismiss = {
    ...guideCompleted,
    dismissGuide: true
  };

  const { guideStep, userUpdate } = getGuidePagesSettings(
    GuideType.FullGuide,
    guideCompletedWithDismiss
  );

  try {
    await authService.readGuideSteps(guideStep);
    dispatch(updateUser(userUpdate));
    onClose?.();
  } catch (error) {
    catchError({
      error,
      default: {
        message: errorMessage
      }
    });
  }
};
